import { jsx } from 'react/jsx-runtime';
import { Stack } from '@grafana/ui';
import '@grafana/data';

const EditorStack = ({ children, wrap: wrapItems = true, ...props }) => {
  var _a, _b;
  return /* @__PURE__ */ jsx(Stack, { wrap: wrapItems ? "wrap" : undefined, direction: (_a = props.direction) != null ? _a : "row", gap: (_b = props.gap) != null ? _b : 2, ...props, children });
};

export { EditorStack };
//# sourceMappingURL=EditorStack.js.map
